var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Card, checkIsPlatform, getTestId, isValidObject, LILAC_400, tokens, TRANSPARENT, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { Image, Pressable, View } from 'react-native';
import { ButtonWidgetComponent as ButtonWidget } from '../button-widget/ButtonWidget';
import { CalloutWidget } from '../callout-widget';
import { CardTitleWidget } from '../card-title-widget';
import { CounterWidget } from '../counter-widget';
import ExtraDataInfo from './components/extra-data-info/ExtraDataInfo';
import PackInfo from './components/pack-info/PackInfo';
import PriceDetails from './components/price-details/PriceDetails';
import Timer from './components/timer/Timer';
import { getOrderSummaryCardWidgetStyles } from './OrderSummaryCardWidgetStyles';
import BelowDataInfo from './components/below-data-info/BelowDataInfo';
export var OrderSummaryCardWidgetComponent = props => {
  var _a;
  var id = props.id,
    index = props.index,
    cardHeaderTitle = props.cardHeaderTitle,
    cardHeaderSubTitle = props.cardHeaderSubTitle,
    cardTitleProps = props.cardTitleProps,
    _props$imageUrl = props.imageUrl,
    imageUrl = _props$imageUrl === void 0 ? '' : _props$imageUrl,
    _props$showAvatar = props.showAvatar,
    showAvatar = _props$showAvatar === void 0 ? false : _props$showAvatar,
    _props$iconProps = props.iconProps,
    iconProps = _props$iconProps === void 0 ? {} : _props$iconProps,
    _props$showShadow = props.showShadow,
    showShadow = _props$showShadow === void 0 ? false : _props$showShadow,
    _props$cardContainerP = props.cardContainerProps,
    cardContainerProps = _props$cardContainerP === void 0 ? {} : _props$cardContainerP,
    incrementalStepperProps = props.incrementalStepperProps,
    _props$tertiaryAction = props.tertiaryActionButtonText,
    tertiaryActionButtonText = _props$tertiaryAction === void 0 ? '' : _props$tertiaryAction,
    _props$tertiarySecond = props.tertiarySecondaryActionButtonText,
    tertiarySecondaryActionButtonText = _props$tertiarySecond === void 0 ? '' : _props$tertiarySecond,
    onTertiaryButtonPress = props.onTertiaryButtonPress,
    onCardPressMetaData = props.onCardPressMetaData,
    onSecondaryTertiaryButtonPress = props.onSecondaryTertiaryButtonPress,
    _onUserAction = props.onUserAction,
    removeCardBorderRadius = props.removeCardBorderRadius,
    removeMarginForActionButton = props.removeMarginForActionButton,
    _props$marginForActio = props.marginForActionButton,
    marginForActionButton = _props$marginForActio === void 0 ? tokens.spacing.SPACING_20 : _props$marginForActio,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OrderSummaryCardWidget' : _props$testID,
    tertiaryActionButtonAccessibilityProps = props.tertiaryActionButtonAccessibilityProps,
    timerInSeconds = props.timerInSeconds,
    calloutProps = props.calloutProps,
    _props$belowDataInfoP = props.belowDataInfoProps,
    belowDataInfoProps = _props$belowDataInfoP === void 0 ? {} : _props$belowDataInfoP,
    restProps = __rest(props, ["id", "index", "cardHeaderTitle", "cardHeaderSubTitle", "cardTitleProps", "imageUrl", "showAvatar", "iconProps", "showShadow", "cardContainerProps", "incrementalStepperProps", "tertiaryActionButtonText", "tertiarySecondaryActionButtonText", "onTertiaryButtonPress", "onCardPressMetaData", "onSecondaryTertiaryButtonPress", "onUserAction", "removeCardBorderRadius", "removeMarginForActionButton", "marginForActionButton", "style", "testID", "tertiaryActionButtonAccessibilityProps", "timerInSeconds", "calloutProps", "belowDataInfoProps"]);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var orderSummaryCardWidgetStyles = getOrderSummaryCardWidgetStyles(isSmallScreen, removeCardBorderRadius, removeMarginForActionButton ? tokens.spacing.SPACING_0 : marginForActionButton);
  var _useState = useState(TRANSPARENT),
    placeholderBgColor = _useState[0],
    setPlaceholderBgColor = _useState[1];
  var tertiaryButtonsize = isSmallScreen ? 'sm' : 'md';
  return _jsx(Pressable, Object.assign({
    onPress: () => onCardPressMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
      id
    }, onCardPressMetaData), {
      index,
      item: props
    }))
  }, checkIsPlatform('web') && {
    tabIndex: 1
  }, cardContainerProps, getTestId(testID), {
    children: _jsxs(Card, Object.assign({
      showShadow: showShadow,
      style: [orderSummaryCardWidgetStyles.card, style]
    }, restProps, getTestId(testID), {
      children: [(!!cardHeaderTitle || !!cardHeaderSubTitle) && _jsx(CardTitleWidget, Object.assign({
        subTitle: cardHeaderSubTitle
      }, getTestId(testID, 'CardTitleWidgetContainer'), {
        title: cardHeaderTitle,
        style: {
          padding: 10
        }
      }, cardTitleProps)), _jsxs(View, Object.assign({
        style: orderSummaryCardWidgetStyles.container
      }, {
        children: [(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.length) > 0 && !showAvatar && _jsx(Image, Object.assign({}, getTestId(testID, 'imageUrl'), {
          source: {
            uri: imageUrl,
            width: 40,
            height: 40
          },
          style: {
            backgroundColor: placeholderBgColor,
            borderRadius: (_a = tokens === null || tokens === void 0 ? void 0 : tokens.borderRadius) === null || _a === void 0 ? void 0 : _a.BORDER_RADIUS_4
          },
          onError: () => setPlaceholderBgColor(LILAC_400)
        })), showAvatar && !!iconProps && Object.keys(iconProps).length > 0 && _jsx(Avatar, Object.assign({
          size: "md"
        }, iconProps, getTestId(testID, 'avatar'))), _jsxs(View, Object.assign({
          style: orderSummaryCardWidgetStyles.orderDetailsContainer
        }, {
          children: [_jsxs(View, Object.assign({
            style: orderSummaryCardWidgetStyles.packDetailsContainer
          }, {
            children: [_jsx(PackInfo, Object.assign({}, props)), isValidObject(props.extraInfoProps) ? _jsxs(View, Object.assign({
              style: orderSummaryCardWidgetStyles.extraDataContainer
            }, {
              children: [_jsx(PriceDetails, Object.assign({}, props)), _jsx(ExtraDataInfo, {
                extraInfoProps: props.extraInfoProps,
                testID: props.testID
              })]
            })) : _jsx(PriceDetails, Object.assign({}, props)), !!timerInSeconds && _jsx(Timer, Object.assign({}, props))]
          })), isValidObject(belowDataInfoProps) && _jsx(BelowDataInfo, Object.assign({}, belowDataInfoProps)), (!!incrementalStepperProps && Object.keys(incrementalStepperProps).length > 0 || (tertiaryActionButtonText === null || tertiaryActionButtonText === void 0 ? void 0 : tertiaryActionButtonText.length) > 0) && _jsxs(View, Object.assign({
            style: [orderSummaryCardWidgetStyles.actionButtonsContainer]
          }, {
            children: [!!incrementalStepperProps && Object.keys(incrementalStepperProps).length > 0 && _jsx(CounterWidget, Object.assign({}, incrementalStepperProps)), (tertiaryActionButtonText === null || tertiaryActionButtonText === void 0 ? void 0 : tertiaryActionButtonText.length) > 0 && _jsx(ButtonWidget, {
              id: id,
              direction: "row",
              buttonAlignment: "flex-start",
              buttonVersionPlatformSpecific: {
                leftCta: {
                  mobile: 'fixed-padding',
                  desktop: 'fixed-padding'
                },
                rightCta: {
                  mobile: 'fixed-padding',
                  desktop: 'fixed-padding'
                }
              },
              onLeftCtaPress: onTertiaryButtonPress,
              leftCta: Object.assign(Object.assign(Object.assign({}, getTestId(testID, 'tertiaryActionButtonText')), {
                buttonType: 'tertiary',
                title: tertiaryActionButtonText,
                size: tertiaryButtonsize
              }), tertiaryActionButtonAccessibilityProps),
              onRightCtaPress: onSecondaryTertiaryButtonPress,
              rightCta: Object.assign(Object.assign(Object.assign({}, getTestId(testID, 'tertiarySecondaryActionButtonText')), {
                buttonType: 'tertiary',
                title: tertiarySecondaryActionButtonText,
                size: tertiaryButtonsize
              }), tertiaryActionButtonAccessibilityProps),
              onUserAction: (actions, extraData) => _onUserAction(Object.assign({
                id
              }, actions), Object.assign(Object.assign({}, extraData), {
                index,
                item: props
              }))
            })]
          }))]
        }))]
      })), isValidObject(calloutProps) && _jsx(CalloutWidget, Object.assign({
        style: orderSummaryCardWidgetStyles === null || orderSummaryCardWidgetStyles === void 0 ? void 0 : orderSummaryCardWidgetStyles.callout
      }, calloutProps))]
    }))
  }));
};
OrderSummaryCardWidgetComponent.genericRendererKey = 'AirOrderSummaryCardWidget';